import { embedSearchWidgetPrefix } from '#/modules/embedSearchWidget/routing/embedSearchWidget.paths';
import { searchJobsPathReference } from '#/modules/search/routing/search.paths';

export const embedSearchWidgetJobsPrefix =
  embedSearchWidgetPrefix.subprefix('jobs');

export const embedSearchWidgetSearchJobsPath =
  embedSearchWidgetJobsPrefix.rootPath(searchJobsPathReference.searchParams);

export const embedSearchWidgetViewJobPath =
  embedSearchWidgetJobsPrefix.path(':jobId');
